exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2kZX4D7RaXyT3-2ICxatvx{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}._20qIJBCxzv10qWvaBdkoBE{color:#f5a623}._20qIJBCxzv10qWvaBdkoBE+._20qIJBCxzv10qWvaBdkoBE{margin-left:.35714rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ScoreStar": "_2kZX4D7RaXyT3-2ICxatvx",
	"ScoreStar_starIcon": "_20qIJBCxzv10qWvaBdkoBE"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/UnitReportHFv4/StudentReportView/ScoreStar/style.postcss
// module id = 1920
// module chunks = 0